// extracted by mini-css-extract-plugin
export default {"component":"SBxcnLQc","title":"UALfiXG1","description":"sa9UaZBl","button":"DorWqQlf"};